module.exports = __webpack_public_path__ + "static/media/VHS_Tape.501129ee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/VHS_Tape.svg
// module id = 35
// module chunks = 1